export default __webpack_public_path__ + "static/media/iPhone.295c038a.png";